<template>
  <div class="deal-type-grid">
    <div
      class="grid-wrapper"
      :class="{ 'small-cards': smallCards }"
    >
      <DealTypeCard
        v-for="dealType in dealTypes"
        :key="dealType.name"
        :dealType="dealType"
        :selected="selected.includes(dealType.name)"
        :disabled="isDisabled(dealType.name)"
        @clicked="toggleSelected(dealType.name)" />
    </div>

    <div
      v-if="selected.length > 0"
      class="button-group">
      <button
        class="default-btn blue"
        @click="$emit('continue', selected)"
      >Continue</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DealTypeCard from './DealTypeCard'

export default {
  name: 'DealTypeGrid',
  components: {
    DealTypeCard,
  },
  props: {
    smallCards: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selected: [],
  }),

  computed: {
    ...mapState('questionnaireStore', {
      dealTypes: ({ questions }) => questions ? questions.dealTypes : [],
    }),
  },

  methods: {
    isDisabled (type) {
      const exclusiveTypes = [
        'External Acquisition (buy out)',
        'Internal Acquisition (buy in)',
        'Recruiting',
      ]

      return exclusiveTypes.includes(type) && this.selected.some(item => {
        return exclusiveTypes.includes(item) && item !== type
      })
    },

    toggleSelected (type) {
      const index = this.selected.indexOf(type)

      if (index === -1) {
        this.selected.push(type)
      } else {
        this.selected.splice(index, 1)
      }

      this.$emit('selected', this.selected)
    },
  },
}
</script>

<style lang="scss" scoped>
.deal-type-grid .default-btn {
  margin-top: 50px;
  width: 200px;
}

.grid-wrapper {
  flex-grow: 1 !important;

  margin: 0;
  display: grid;
  grid-template-columns: 100%;
  grid-auto-rows: auto;
  grid-column-gap: 15px;
  grid-row-gap: 15px;

  justify-content: center;

  @include md {
    margin: auto;
    grid-template-columns: repeat(3, 145px);
    grid-gap: 20px;
  }

  @include lg {
    grid-template-columns: repeat(3, auto);
    grid-gap: 50px;
  }

  &.small-cards {
    @include md {
      grid-template-columns: repeat(3, 130px);
      grid-gap: 20px;
    }

    @include lg {
      grid-template-columns: repeat(3, auto);
      grid-gap: 50px;
    }
  }
}
</style>
